import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { PostDatedPrescriptionDetails } from "../../Apis/AuthApiServices";
import {
  loadingPostDatedPresDetails,
  setPostDatedPresDetails,
} from "../Slice/PostDatedPresDetailsSlice";

function* onLoadPostDatedPresDetailsAsync({ payload }: any) {
  const params = new URLSearchParams();
  params.append("doctorId", payload.doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  try {
    const result: AxiosResponse = yield PostDatedPrescriptionDetails(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setPostDatedPresDetails({
          PostDatedPresDetailsData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setPostDatedPresDetails({
          PostDatedPresDetailsData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setPostDatedPresDetails({
        PostDatedPresDetailsData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadPostDatedPresDetails() {
  yield takeLatest(
    loadingPostDatedPresDetails.type,
    onLoadPostDatedPresDetailsAsync
  );
}

const PostDatedPresDetailsSaga = [fork(onLoadPostDatedPresDetails)];
export default PostDatedPresDetailsSaga;
